import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  padding: 100px 0;
  width: 100%;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;

export const Title = styled.div`
  ${typographyV2.titleBase};
  color: var(--text-default);
`;

export const ViewPastNotificationsButton = styled.div`
  ${typographyV2.uiXs};
  color: var(--text-primary);
  cursor: pointer;
`;
